import {Injectable, TransferState} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {env} from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class ApiService {

    //Документации пока нет
    public apiHost = this.resolveApiHost();

    public httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        })
    };

    constructor(
        public http: HttpClient,
        public transferState: TransferState
    ) {
    }

    private resolveApiHost(): string {
        if (typeof window !== 'undefined') {
            return this.resolveBrowserApiHost();
        }

        const runtimeApiHost = (globalThis as any)?.process?.env?.['URL_API'];

        return runtimeApiHost || env.URL_API;
    }

    private resolveBrowserApiHost(): string {
        const apiHost = env.URL_API;

        if (!env.production && window.location.protocol === 'https:' && this.isLocalHttpApi(apiHost)) {
            return '/api';
        }

        return apiHost;
    }

    private isLocalHttpApi(apiHost: string): boolean {
        try {
            const url = new URL(apiHost);

            return url.protocol === 'http:' && ['localhost', '127.0.0.1', '::1'].includes(url.hostname);
        } catch {
            return false;
        }
    }

    showError(err: any, defaultText: string = 'Неизвестная ошибка'): void {
        let error = '';
        if (Array.isArray(err?.error)) {
            err.error?.forEach((item: any) => {
                error += `<li>${item?.message}</li>`
            });
        }
        error = error ? `<ul class="px-0 mb-0">${error}</ul>` : err?.error?.message || defaultText;
        this.alertDanger("Ошибка", error);
    }

    alertDanger(title: string, message: string) {
        /*this.alerts.open(message, {
            label: title,
            appearance: 'negative',
            autoClose: 5000,
        }).subscribe();*/
    }

    /** Log a WidgetService message with the MessageService */
    public log(message: string) {
        //this.messageService.add(`WidgetService: ${message}`);
        console.log(`MotorDesk: ${message}`);
    }

}
